import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import zhHant from "./zh-Hant";

/**
 * i18n 架構預埋(主計劃 P0 / DoD 第 5 條)。
 *
 * 第一階段:key-based 架構 + 繁體中文全站。
 * 第二階段:補英文語系(en)與匯出檔雙語驗證 —— 屆時新增 resources.en 即可,元件不改。
 *
 * 用法(元件):
 *   import { useTranslation } from "react-i18next";
 *   const { t } = useTranslation();
 *   t("common.add");  t("accounts.users.title");  t("common.perPage", { n: 30 });
 */
i18n.use(initReactI18next).init({
  resources: {
    "zh-Hant": { translation: zhHant },
  },
  lng: "zh-Hant",
  fallbackLng: "zh-Hant",
  interpolation: { escapeValue: false }, // React 已防 XSS
  react: { useSuspense: false }, // 資源為 bundle 內建,免 Suspense
});

export default i18n;
